import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { manageFootballTeamService } from "../../../../../../commons";

export interface IManageTeamManagerAddState {
  manageTeamManagerAddStatus: StatusEnum;
}

export interface IManageTeamManagerAddOption {
  teamId: number;
  userId: number;
}

const initialState: IManageTeamManagerAddState = {
  manageTeamManagerAddStatus: StatusEnum.Idle,
};

export const teamManagerAdd = createAsyncThunk(
  "manage/teamManagerAdd",
  async (options: IManageTeamManagerAddOption, thunkAPI) => {
    try {
      const manageTeamManagerAdd = await manageFootballTeamService.addTeamManager(options.teamId, options.userId);
      return manageTeamManagerAdd;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageTeamManagerAddSlice = createSlice({
  name: "manageTeamManagerAddSlice",
  initialState: initialState,
  reducers: {
    cleanUpTeamManagerAdd(state) {
      state.manageTeamManagerAddStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(teamManagerAdd.pending, (state) => {
        state.manageTeamManagerAddStatus = StatusEnum.Loading;
      })
      .addCase(teamManagerAdd.fulfilled, (state) => {
        state.manageTeamManagerAddStatus = StatusEnum.Succeeded;
      })
      .addCase(teamManagerAdd.rejected, (state) => {
        state.manageTeamManagerAddStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpTeamManagerAdd } = manageTeamManagerAddSlice.actions;
export default manageTeamManagerAddSlice.reducer;
